'use client'

import type { TextClampProps } from '@pearlconvert/ui/components/text-clamp/text-clamp.types'

import { useCallback } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { type EventPayloadType, EventType } from '@maestro/data-layer'
import { TextClamp } from '@pearlconvert/ui/components/text-clamp'

export interface TrackingTextClampProps extends TextClampProps {
  location?: string
}

export default function TrackingTextClamp({
  location = 'PLP',
  ...props
}: TrackingTextClampProps) {
  const { publish } = useEventBusContext()

  const handleToggle = useCallback(() => {
    publish<EventPayloadType[EventType.CTA_CLICKED]>(EventType.CTA_CLICKED, {
      location,
      click_text: 'Show more',
    })
  }, [location, publish])

  return <TextClamp {...props} onToggle={handleToggle} />
}
